import { render, staticRenderFns } from "./SelectorsForm.vue?vue&type=template&id=1580deb0&"
import script from "./SelectorsForm.vue?vue&type=script&lang=ts&"
export * from "./SelectorsForm.vue?vue&type=script&lang=ts&"
import style0 from "./SelectorsForm.vue?vue&type=style&index=0&id=1580deb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports